export class CustomerInsightsApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** One rider's activity summary in a market (`analytics:view` + `analytics:view_personal`); access-logged. An unknown customer is 200 with zeros. */
    summary(customerId, market) {
        return this.client.request({
            method: 'GET',
            path: `/v1/analytics/customers/${encodeURIComponent(customerId)}/summary?market=${encodeURIComponent(market)}`,
            auth: true,
        });
    }
    /** One provider's performance and earnings insights in a market (`analytics:view` + `analytics:view_personal`); access-logged. An unknown driver is 200 with `known: false`. */
    driver(driverId, market) {
        return this.client.request({
            method: 'GET',
            path: `/v1/analytics/drivers/${encodeURIComponent(driverId)}/insights?market=${encodeURIComponent(market)}`,
            auth: true,
        });
    }
}
//# sourceMappingURL=customer-insights.js.map